import { Component, OnInit, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import 'leaflet';
import 'leaflet.markercluster';
import * as L from 'leaflet';

const map = {
  OPENSTREETMAP_URL: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  OPENSEAMAP_URL: 'https://tiles.openseamap.org/seamark/{z}/{x}/{y}.png',
  SAT_URL: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
};

const BOAT_MARKER_ICON = L.icon({
  iconUrl: 'assets/icons/boat-icon-map.svg',
  iconSize: [20, 20], // size of the icon
  shadowSize: [0, 0], // size of the shadow
  iconAnchor: [0, 0], // point of the icon which will correspond to marker's location
  shadowAnchor: [0, 0], // the same for the shadow
  popupAnchor: [10, 0], // point from which the popup should open relative to the iconAnchor
});

@Component({
  selector: 'app-map-get-point',
  templateUrl: './map-get-point.component.html',
  styleUrls: ['./map-get-point.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MapGetPointComponent implements OnInit {


  @Input() actualCoord!: string;
  @Input() initCoord!: string;
  @Input() initialMapZoom = 6;
  @Input() defaultMapZoom = 6;
  @Input() isReadOnly: boolean = false;
  @Output() onClickPoint = new EventEmitter();

  editPos = false;
  initialCoord!: string;

  // If no boat location, default to France location
  defaultLocation = {
    latitude: 46.7111,
    longitude: 1.7191,
  };

  pointMap: any;


  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  async ngOnInit() {
    this.initialCoord = this.actualCoord;
    this.mountMap();
  }

  mountMap(): void {


    let { latitude, longitude } = this.defaultLocation;
    if (this.initCoord && this.initCoord.split(',').length > 1) {
      latitude = parseFloat(this.initCoord.split(',')[0].trim());
      longitude = parseFloat(this.initCoord.split(',')[1].trim());
    } else {
      this.initialMapZoom = 5;
    }
    // Create Boat Map on the div with id="map" and initialize coor. and zoom
    this.pointMap = L.map('pointMap').setView([latitude, longitude], this.initialMapZoom);
    // Add "Open Street Map" Tile to the Map
    L.tileLayer(map.OPENSTREETMAP_URL, {
      attribution: 'Nauticoncept',
    }).addTo(this.pointMap);
    // Add "Open Sea Map" Tile to the Map
    L.tileLayer(map.OPENSEAMAP_URL).addTo(this.pointMap);

    this.pointMap.on('click', (e: any) => {
      this.addPosition(e.latlng);
    });

    this.addBoatToMap(true);

  }

  addBoatToMap(fitBounds = false) {

    const LWithClusterGroup = L as any;
    const markers = LWithClusterGroup.markerClusterGroup();
    if (this.actualCoord) {
      const lat = this.actualCoord.split(',')[0];
      const lng = this.actualCoord.split(',')[1];
      const point = { lat: parseFloat(lat), lng: parseFloat(lng) };

      const pointBonds: L.LatLngExpression = point;

      let boatIcon = BOAT_MARKER_ICON;
      const marker: any = L.marker(point, {
        icon: boatIcon,
      }).addTo(this.pointMap);
      markers.addLayer(marker);
      this.pointMap.addLayer(markers);
      if (fitBounds)
        this.pointMap.fitBounds([pointBonds]);
    }

  }

  addPosition(latLng: any) {
    if (this.editPos) {
      this.actualCoord = `${latLng.lat}, ${latLng.lng}`;

      this.removeMarkers();
      this.addBoatToMap();
    }

  }

  savePos() {
    this.onClickPoint.emit(this.actualCoord);
    this.activeModal.close();
  }

  removeMarkers() {
    if (this.pointMap) {
      this.pointMap.eachLayer((layer: any) => {
        if (!layer._url) {
          this.pointMap.removeLayer(layer);
        }
      });
    }
  }


  closeModal() {
    this.activeModal.close();
  }

  editPosition() {
    let obj = document.getElementById('pointMap');
    if (obj) {
      obj.style.cursor = 'crosshair';
    }
    this.editPos = true;
  }

  cancelEdition() {
    this.actualCoord = this.initialCoord;
    this.removeMarkers();
    this.addBoatToMap(true);
    let obj = document.getElementById('pointMap');
    if (obj) {
      obj.style.cursor = '';
    }
    this.editPos = false;
  }

}
